import { Ellipsis, Trash } from '@clearkit/icons';
import classnames from 'classnames';
import { CKActionMenu, CKBox, CKButton, CKPopover, CKTag } from 'clearkit';

import { CustomObject } from '~/generated/graphql';

type ConfiguredCustomObjectsTableProps = {
  items: CustomObject[];
  onDisable: (object: CustomObject) => void;
};
export function ConfiguredCustomObjectsTable({
  items,
  onDisable,
}: ConfiguredCustomObjectsTableProps) {
  if (!items.length) {
    return null;
  }
  /**
   * @todo Replace this with CKLayoutGrid component when ready
   */
  const gridClasses =
    'grid items-center grid-cols-[1fr_1fr_3.125rem] gap-4 w-full px-5 py-3';

  return (
    <CKBox className="my-4" variant="card">
      <header className={classnames(gridClasses)}>
        <HeaderLabel>Linked objects</HeaderLabel>
        <HeaderLabel>Key for enrichment</HeaderLabel>
      </header>
      {items.map((object) => (
        <div className={classnames('border-t', gridClasses)} key={object.id}>
          <ObjectLabel>{object.externalObjectName}</ObjectLabel>
          <ObjectLabel>{object.identifierField}</ObjectLabel>
          <CKPopover
            placement="bottom-end"
            popover={
              <CKActionMenu>
                <CKActionMenu.Item
                  icon={<Trash />}
                  isDestructive
                  onClick={() => onDisable(object)}
                >
                  <span>Remove object from enrichment list</span>
                </CKActionMenu.Item>
              </CKActionMenu>
            }
          >
            <CKButton className="ck-focus-ring" size="small">
              <Ellipsis />
            </CKButton>
          </CKPopover>
        </div>
      ))}
    </CKBox>
  );
}

const HeaderLabel = ({ children }: { children: React.ReactNode }) => (
  <h4 className="flex-1 text-sm font-medium text-gray-700">{children}</h4>
);

const ObjectLabel = ({ children }: { children: React.ReactNode }) => (
  <div className="flex-1">
    <CKTag className="bg-blue">{children}</CKTag>
  </div>
);
